import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import tierList from "../imgs/tier-list-example.png";
import Image from "material-ui-image";
import SignInForm from "../components/SignInForm";
import { Typography, Button } from "@mui/material";
import { getAuth } from "firebase/auth";
import { useState, useEffect } from "react";
import Spinner from "../components/Spinner.jsx";

function Home(props) {
  const { setAppState } = props;
  const [loading, setLoading] = useState(true);
  const auth = getAuth();
  let user = auth.currentUser;

  useEffect(() => {
    auth.onAuthStateChanged((myUser) => {
      if (myUser) {
        setUserData({
          email: myUser.email,
          name: myUser.displayName,
        });
      } else {
        setUserData({
          email: null,
          name: null,
        });
      }
      setLoading(false);
    });
    //eslint-disable-next-line
  }, []);

  const [userData, setUserData] = useState({
    email: user ? user.email : "",
    name: user ? user.displayName : "",
  });

  const onLogout = () => {
    auth.signOut();
    user = null;
    setAppState((prevState) => ({ ...prevState, currentUser: null }));
  };

  return (
    <Container
      sx={{
        minHeight: "calc(100vh - 56px)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Grid container gap={2}>
        <Grid item xs={12} md={6} lg={8}>
          <Typography variant="h3" component="h1" className="text-align-center">
            Welcome to the Tier List <br /> Creator App
          </Typography>
          <br />
          <Box sx={{ width: "300px", margin: "auto" }}>
            <Image src={tierList} alt="" />
          </Box>
          <p className="text-align-center">
            Create your own custom tier lists and easily share them
          </p>
        </Grid>
        <Grid
          item
          xs={12}
          zeroMinWidth
          md
          lg
          display="flex"
          flexDirection="column"
          justifyContent="center"
        >
          {loading ? (
            <Spinner />
          ) : !user ? (
            <SignInForm
              setAppState={setAppState}
              setUserData={setUserData}
              userData={userData}
            />
          ) : (
            <>
              <Typography variant="h3" component="h4">
                Hello
              </Typography>
              <p>{userData.email}</p>
              <p>{userData.name}</p>
              <Button className="logOut" variant="contained" onClick={onLogout}>
                Logout
              </Button>
            </>
          )}
        </Grid>
      </Grid>
    </Container>
  );
}

export default Home;
